import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import Feed from './InstagramGallery.component'
import './InstaFeeds.styles.css'

const InstaFeeds = ({...props}) => {
    const token="IGQVJVYm5aOTFtOFgxZAVpuWTZAnUVE5MVZApTTE0ankwWWZA6MTRQNXNYOWVaYXhtVS1hUWtiNW5fNW5VZATZACdElOdWFBMU1VZA1lSRGFWeU5IcWxUS081ZA3gxWm4yMGRUX3V2TkFUa3hIbGhteWR0eUEzagZDZD";
    const [feeds, setFeedsData] = useState([])
    const tokenProp = useRef(token);
    tokenProp.current = token;

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchInstagramPost () {
          try{
            axios
                .get(`https://graph.instagram.com/me/media?fields=id,media_type,media_url,caption&limit=${props.limit}&access_token=${token}`)
                .then((resp) => {
                    setFeedsData(resp.data.data)
                })
          } catch (err) {
              console.log('error', err)
          }
        }
        
        fetchInstagramPost();
  
        return () => {
            abortController.abort(); 
        };
    }, [props.limit])

    return (
        <div className="container">
            {feeds.map((feed) => (
                <Feed key={feed.id} feed={feed} />
            ))}
        </div>
    );
}

export default InstaFeeds;